var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCheckChip = function SvgIconCheckChip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3C8FF8",
    fillRule: "evenodd",
    d: "M17.856 5.004a1.72 1.72 0 0 1 0 2.436l-8.61 8.61a1.72 1.72 0 0 1-2.436 0l-4.306-4.305A1.722 1.722 0 1 1 4.94 9.31l3.087 3.087 7.394-7.393a1.72 1.72 0 0 1 2.435 0",
    clipRule: "evenodd"
  })));
};
export default SvgIconCheckChip;